import React from 'react'
import { connect } from 'react-redux'
import Modal from 'react-responsive-modal'
import CouponActions from '../../Redux/CouponRedux'

class RenderTable extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      showModal: null,
      detail: {}
    }
  }

  componentDidMount = () => {
    this.props.fetchCouponItem()
  }

  _toggleModal = (modalID = null) => {
    this.setState({ showModal: modalID })
    if (!modalID) {
      this.props.fetchCouponItem()
    }
  }

  _selectItem = (item, modalID) => {
    this.setState({ detail: item })
    this._toggleModal(modalID)
  }

  _deleteCouponItem = (couponUUID, couponItemId) => {
    let data = {
      couponUUID,
      couponItemId
    }
    this.props.deleteCouponItem(data)
    setTimeout(() => {
      this._toggleModal()
    }, 500)
  }

  _catchDiscountableType = (input) => (input === 'product' ? 'modem' : input)

  _renderTableBody = (data) => {
    return (
      data.map((item, i) => (
        <tr key={i}>
          <td className='text-center' style={{ textTransform: 'capitalize' }}>
            { this._catchDiscountableType(item.discountable_type) }
          </td>
          <td className='text-center'>
            { this._renderTableRow(item.discountable_type, i) }
          </td>
          <td className='text-center'>
            <button className='btn btn-danger' onClick={() => this._selectItem(item, 'delete')}>
              <i className='fa fa-trash' />
            </button>
          </td>
        </tr>
      ))
    )
  }

  _renderTableRow = (type, i) => {
    const { coupon } = this.props
    switch (type) {
      case 'product':
        return coupon.couponitem[i].product.title
      case 'attraction':
        return coupon.couponitem[i].attraction.title
      case 'insurance':
        return coupon.couponitem[i].travel_package.name
      case 'inventory':
        return coupon.couponitem[i].inventory.name
      case 'category':
        return coupon.couponitem[i].category.name
      default:
        return null
    }
  }

  render () {
    let { coupon } = this.props
    return (
      <section>
        <div className='section'>
          <table className='table table-striped table-hover'>
            <thead>
              <tr>
                <th className='text-center'>Type</th>
                <th className='text-center'>Name</th>
                <th className='text-center'>Delete</th>
              </tr>
            </thead>
            <tbody>
              {
                (!coupon.fetching || !coupon.processing) &&
                coupon.couponitem && coupon.couponitem.length > 0
                  ? this._renderTableBody(coupon.couponitem)
                  : <tr>
                    <td colSpan='3' className='text-center'>--No Data--</td>
                  </tr>
              }
            </tbody>
          </table>
        </div>
        <Modal center open={this.state.showModal === 'delete'} onClose={this._toggleModal}>
          <section className='section' style={{ width: '40vw' }}>
            <div className='title-block'>
              <h3 className='title'>Confirm deletion</h3>
            </div>
            <div className='text-center'>
              <button onClick={() => this._toggleModal()} className='btn btn-lg btn-secondary mr-2'>Cancel</button>
              <button onClick={() => this._deleteCouponItem(this.state.detail.coupon_id, this.state.detail.id)} className='btn btn-lg btn-danger'>Delete</button>
            </div>
          </section>
        </Modal>
      </section>
    )
  }
}

const stateToProps = (state) => ({
  coupon: state.coupon
})

const dispatchToProps = (dispatch) => ({
  deleteCouponItem: (data) => dispatch(CouponActions.deleteCouponItemRequest(data))
})

export default connect(stateToProps, dispatchToProps)(RenderTable)



// WEBPACK FOOTER //
// ./src/Containers/Coupon/RenderTable.js